<template>
  <transition-group name="list" tag="div" class="notifications">
    <span v-for="(notification, index) in notifications" :key="'notification-wrapper-' + index"
      class="notification-toast" :class="notification.type">
      <span class="notification-message">{{ notification.message }}</span>
      <button class="close-btn" @click="removeNotification(index)" aria-label="Close notification">
        &times;
      </button>
    </span>
  </transition-group>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      notifications: state => state.notificationsModule.notifications
    }),
    ...mapGetters({
      getNotifications: 'notificationsModule/getNotifications'
    })
  },
  methods: {
    removeNotification(index) {
      this.$store.dispatch('notificationsModule/removeNotification', index);
    }
  }
}

</script>

<style scoped>
.notification-toast.success {
  border-left-color: #4caf50;
}

.notification-toast.danger {
  border-left-color: #f44336;
}

.notification-toast.warning {
  border-left-color: #ff9800;
}

.notification-toast.info {
  border-left-color: #2196f3;
}


.notifications {
  width: auto;
  pointer-events: none;
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.3rem;
}


.notification-toast {
  width: auto;
  min-width: 280px;
  max-width: 360px;
  background: #fff;
  color: #333;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  pointer-events: auto;
  border-left: 5px solid #F1F1F1;
  transition: box-shadow 0.2s;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.notification-message {
  max-width: 260px;
  word-wrap: break-word;
}


.close-btn {
  background: transparent;
  border: none;
  color: #888;
  font-size: 1.2rem;
  cursor: pointer;
  margin-left: 12px;
  padding: 0 4px;
  transition: color 0.2s;
  pointer-events: auto;
}

.close-btn:hover {
  color: #333;
}

/* Transition styles for toasts */
.list-enter-active,
.list-leave-active {
  transition: all 0.4s cubic-bezier(.25, .8, .25, 1);
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
